<template>
    <div class="tabs_nav">
        <BtnTab :class="{'has-error': !formValidity[0]}" btn-id="FormStep1" :active-tab="isActive('FormStep1')" @btnTab:Clicked="changeTab">
            {{ $t('modules.positions.topbar.TabName') }}
        </BtnTab>
        <BtnTab :class="{'has-error': !formValidity[1]}" btn-id="FormStep2" :active-tab="isActive('FormStep2')" @btnTab:Clicked="changeTab">
            {{ $t('modules.positions.topbar.TabAssociatedRef') }}
        </BtnTab>
        <BtnTab :class="{'has-error': !formValidity[2]}" btn-id="FormStep4" :active-tab="isActive('FormStep4')" @btnTab:Clicked="changeTab">
            {{ $t('modules.positions.topbar.TabCustomEmail') }}
        </BtnTab>
        <BtnTab :class="{'has-error': !formValidity[3]}" btn-id="FormStep5" :active-tab="isActive('FormStep5')" @btnTab:Clicked="changeTab">
            {{ $t('modules.positions.topbar.TabCampaignLink') }}
        </BtnTab>
    </div>
</template>

<script>
export default {
    name: 'TopbarTabs',
    components: {},
    data(){
        return {}
    },
    computed: {
        formValidity(){
            return this.$store.state.PositionStore.formValidity
        },
        formStepsName(){
            return this.$store.state.PositionStore.formStepsName
        },
        currentStepComponent(){
            return this.$store.state.PositionStore.formStepsName[this.$store.state.PositionStore.formCurrentStep]
        },
        formCurrentStep(){
            return this.$store.state.PositionStore.formCurrentStep
        }
    },
    methods: {
        changeTab(tabName){
            const tabIndex = this.formStepsName.indexOf(tabName)
            if(tabIndex != -1){
                this.$store.commit('PositionStore/changeCurrentStep', { index: tabIndex})
            }
        },
        isActive(tabName){
            return this.currentStepComponent == tabName
        }
    }
}
</script>
<style lang="scss">
    .tabs_nav{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: stretch;
        padding-left: 70px;
        a{
            line-height: 60px;
        }
    }
</style>
